import { SxProps, Theme } from '@mui/material';
import { Color } from 'shared/utils/colors';

export const ELLIPSIS_TEXT_SX: SxProps<Theme> = {
  minWidth: 0,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  width: '100%',
  maxWidth: '100%',
};

export const FILTER_COUNT_BADGE_SX: SxProps<Theme> = (theme) => ({
  fontSize: '0.5rem',
  position: 'absolute',
  top: 2,
  right: 2,
  padding: '2px 4px',
  backgroundColor: theme.palette.primary.main,
  border: `thin solid ${theme.palette.primary.main}`,
  borderRadius: '50%',
  color: 'rgba(0, 0, 0, 0.85)',
});

export const sxStyles = {
  table: {
    overflow: 'hidden',
    border: 'none',
    '& .MuiDataGrid-cell': {
      outline: 'none',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
    },
    '& .MuiDataGrid-cell--withRenderer': {
      justifyContent: 'flex-start',
    },
    '& .MuiDataGrid-cellCheckbox': {
      justifyContent: 'center',
      '& .MuiCheckbox-root': {
        margin: 0,
      },
    },
    '& .MuiDataGrid-columnHeaderCheckbox': {
      justifyContent: 'center',
      '& .MuiCheckbox-root': {
        margin: 0,
      },
    },
    '& .MuiDataGrid-cell:focus': {
      outline: 'none',
    },
    '& .MuiDataGrid-cell:focus-within': {
      outline: 'none',
    },
    '& .MuiDataGrid-row': {
      cursor: 'pointer',
      // Neutral hover so it stays clearly distinct from the brand-yellow selected state.
      '&:hover': {
        backgroundColor: Color.scrimBlack06,
      },
      '&.Mui-selected': {
        backgroundColor: Color.selectedRowTint,
        // Non-color reinforcement (WCAG 1.4.11): left accent bar + bolder text,
        // so selection is identifiable beyond the subtle background tint.
        boxShadow: `inset 3px 0 0 0 ${Color.primaryOrangeDark}`,
        '& .MuiDataGrid-cell': {
          fontWeight: 600,
        },
        '&:hover': {
          backgroundColor: Color.primaryOrangeActive,
        },
      },
    },
  },
};

